import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'offer-section',
  templateUrl: './offer-section.component.html',
  styleUrls: ['./offer-section.component.scss']
})
export class OfferSectionComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
